const validateCompound = (...errors: string[]): string => errors.find((error) => error.length > 0) ?? '';

export default validateCompound;
